import i18n from '@/i18n'
export default [
  // {
  //   path: 'spareRequirementsList',
  //   component: () => import('@/views/modules/storeSpare/spareRequirements/spareRequirementsList'),
  //   name: 'spareRequirementsList',
  //   meta: { title: '备件需求', needToken: true }
  // },
  // {
  //   path: 'spareRequirementsAdd',
  //   component: () => import('@/views/modules/storeSpare/spareRequirements/spareRequirementsAdd'),
  //   name: 'spareRequirementsAdd',
  //   meta: { title: '备件需求单新增', needToken: true }
  // },
  // {
  //   path: 'spareRequirementsDetail',
  //   component: () => import('@/views/modules/storeSpare/spareRequirements/spareRequirementsDetail'),
  //   name: 'spareRequirementsDetail',
  //   meta: { title: '备件需求单详情', needToken: true }
  // },
  // {
  //   path: 'spareRequirementsUpdate',
  //   component: () => import('@/views/modules/storeSpare/spareRequirements/spareRequirementsUpdate'),
  //   name: 'spareRequirementsUpdate',
  //   meta: { title: '备件需求单维护', needToken: true }
  // },
  // {
  //   path: 'spareGetList',
  //   component: () => import('@/views/modules/storeSpare/spareGet/spareGetList'),
  //   name: 'spareGetList',
  //   meta: { title: '备件领用', needToken: true }
  // },
  // {
  //   path: 'spareGetAdd',
  //   component: () => import('@/views/modules/storeSpare/spareGet/spareGetAdd'),
  //   name: 'spareGetAdd',
  //   meta: { title: '备件领用单新增', needToken: true }
  // },
  // {
  //   path: 'spareGetDetail',
  //   component: () => import('@/views/modules/storeSpare/spareGet/spareGetDetail'),
  //   name: 'spareGetDetail',
  //   meta: { title: '备件领用单详情', needToken: true }
  // },
  // {
  //   path: 'spareGetDetailUpdate',
  //   component: () => import('@/views/modules/storeSpare/spareGet/spareGetDetailUpdate'),
  //   name: 'spareGetDetailUpdate',
  //   meta: { title: '备件领用单维护', needToken: true }
  // },
  // {
  //   path: 'spareGetDetailUpdate',
  //   component: () => import('@/views/modules/storeSpare/spareGet/spareGetDetailUpdate'),
  //   name: 'spareGetDetailUpdate',
  //   meta: { title: '备件领用单维护', needToken: true }
  // },
  // {
  //   path: 'spareStatementList',
  //   component: () => import('@/views/modules/storeSpare/spareStatement/spareStatementList'),
  //   name: 'spareStatementList',
  //   meta: { title: '对账单', needToken: true }
  // },
  {
    path: 'spareOrderPay',
    component: () => import('@/views/modules/storeSpare/spareStatement/orderPay'),
    name: 'spareOrderPay',
    meta: { title: '支付', needToken: true }
  },
  // {
  //   path: 'sparePartsLibrary',
  //   component: () => import('@/views/modules/storeSpare/sparePartsLibrary/sparePartsLibrary'),
  //   name: 'sparePartsLibrary',
  //   meta: { title: '备件库', needToken: true }
  // },
  // {
  //   path: 'spareGoodsList',
  //   component: () => import('@/views/modules/storeSpare/sparePartsLibrary/spareGoodsList'),
  //   name: 'spareGoodsList',
  //   meta: { title: '物品领用清单', needToken: true }
  // },
  // {
  //   path: 'storeSpareIndex',
  //   component: () => import('@/views/modules/storeSpare/storeSpareIndex'),
  //   name: 'storeSpareIndex',
  //   meta: { title: '联储联备', needToken: false }
  // },
  // ---
  {
    path: 'storeSpare',
    component: () => import('@/views/modules/storeSpare/index'),
    name: 'storeSpare',
    meta: { title: i18n.t('header.dashboard'), needToken: true }
  },
  {
    path: 'sparePartsDistribution',
    component: () => import('@/views/modules/storeSpare/sparePartsDistribution'),
    name: 'sparePartsDistribution',
    meta: { title: '备件分布', needToken: true }
  },
  {
    path: 'sparePartsLibrary',
    component: () => import('@/views/modules/storeSpare/storeStock/index'),
    name: 'sparePartsLibrary',
    meta: { title: i18n.t('header.stockInquiry'), needToken: true }
  },
  {
    path: 'sparePartsLibraryGoodDetail',
    component: () => import('@/views/modules/storeSpare/storeStock/goodDetail'),
    name: 'sparePartsLibraryGoodDetail',
    meta: { title: i18n.t('route.stockGoods'), needToken: true }
  },
  {
    path: 'spareShareGoodsDetail',
    component: () => import('@/views/modules/storeSpare/storeStock/spareShareGoodsDetail'),
    name: 'spareShareGoodsDetail',
    meta: { title: '共享备件详情', needToken: true }
  },
  {
    path: 'spareStatementList',
    component: () => import('@/views/modules/storeSpare/storeCollect/index'),
    name: 'spareStatementList',
    meta: { title: '对账结算', needToken: true }
  },
  {
    path: 'shareGoodList',
    component: () => import('@/views/modules/storeSpare/sharedSpareParts/shareGoodList'),
    name: 'shareGoodList',
    meta: { title: '共享备件', needToken: true }
  },
  {
    path: 'shareGoodDetail',
    component: () => import('@/views/modules/storeSpare/sharedSpareParts/goodDetail'),
    name: 'shareGoodDetail',
    meta: { title: '共享商品', needToken: true }
  },
  {
    path: 'spareRequirementsList',
    component: () => import('@/views/modules/storeSpare/requirement/spareRequirementsList'),
    name: 'spareRequirementsList',
    meta: { title: i18n.t('header.spareRequisition'), needToken: false }
  },
  {
    path: 'spareRequirementsAdd',
    component: () => import('@/views/modules/storeSpare/requirement/spareRequirementsAdd'),
    name: 'spareRequirementsAdd',
    meta: { title: i18n.t('route.addRequisitionNeed'), needToken: false }
  },
  {
    path: 'spareRequirementsDetail',
    component: () => import('@/views/modules/storeSpare/requirement/spareRequirementsDetail'),
    name: 'spareRequirementsDetail',
    meta: { title: i18n.t('route.requisitionNeedDetail'), needToken: false }
  },
  {
    path: 'spareRequirementsUpdate',
    component: () => import('@/views/modules/storeSpare/requirement/spareRequirementsUpdate'),
    name: 'spareRequirementsUpdate',
    meta: { title: i18n.t('route.requisitionNeedUpdate'), needToken: false }
  },
  {
    path: 'spareGetList',
    component: () => import('@/views/modules/storeSpare/neckband/spareGetList'),
    name: 'spareGetList',
    meta: { title: i18n.t('header.spareOrder'), needToken: true }
  },
  {
    path: 'spareGetAdd',
    component: () => import('@/views/modules/storeSpare/neckband/spareGetAddNew'),
    name: 'spareGetAdd',
    meta: { title: i18n.t('route.addRequisitionOrder'), needToken: false }
  },
  {
    path: 'spareGetDetail',
    component: () => import('@/views/modules/storeSpare/neckband/spareGetDetailNew'),
    name: 'spareGetDetail',
    meta: { title: i18n.t('route.requisitionOrderDetail'), needToken: false }
  },
  {
    path: 'spareGetDetailUpdate',
    component: () => import('@/views/modules/storeSpare/neckband/spareGetDetailUpdateNew'),
    name: 'spareGetDetailUpdate',
    meta: { title: i18n.t('route.requisitionOrderUpdate'), needToken: false }
  },
  {
    path: 'spareStatementDetail',
    component: () => import('@/views/modules/storeSpare/spareStatement/spareStatementDetail'),
    name: 'spareStatementDetail',
    meta: { title: '对账单详情', needToken: true }
  },
  {
    path: 'sharedSpareParts',
    component: () => import('@/views/modules/storeSpare/sharedSpareParts/index'),
    name: 'sharedSpareParts',
    meta: { title: '备件发布', needToken: true }
  }
]
